module.exports = __webpack_public_path__ + "static/img/edit_p.cb3afd60.png";